export const PIE_COLORS = [
  "#327de3", "#0E7036", "#F59E0B", "#D92D20", "#7C3AED", "#0891B2",
  "#DB2777", "#65A30D", "#EA580C", "#0E4B92", "#14B8A6", "#A21CAF",
];

export const SECTION_KEYS = ["spend", "comparison", "expenses", "vendor", "revenue"];

export const VIEW_OPTIONS = [
  { key: "summary", label: "Summary" },
  { key: "pnl", label: "PNL" },
  { key: "balance", label: "Balance Sheet" },
];

export const SECTION_OPTIONS = [
  { key: "summary",       label: "Project summary" },
  { key: "kpis",          label: "KPI cards" },
  { key: "gross-revenue", label: "Gross Revenue" },
  { key: "profit",        label: "Profit Projection" },
  { key: "spend",         label: "Spend by Category" },
  { key: "comparison",    label: "Budget vs Spent" },
  { key: "expenses",      label: "Expenses" },
  { key: "vendor",        label: "Expenses by Vendor" },
  { key: "revenue",       label: "Revenue" },
];
